import { useParams } from 'react-router-dom';
import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import { useUser, useUpdateUser, useUpdateUserFeedback } from 'api/userApi';
import { UserForm } from './components';
import { useIntl } from 'react-intl';
import { Loading } from 'components/loading';

export default function ViewUser() {
  const intl = useIntl();
  const { id } = useParams();
  const { data, isLoading, isFetching } = useUser({
    id,
  });
  const updateMutation = useUpdateUser(id);
  const updateMutationFeedback = useUpdateUserFeedback(id);

  const handleSubmit = (values) => {
    updateMutationFeedback.mutate(values, {
      onSuccess: (res) => {
        if (res) {
          updateMutation.mutate(values, {
            onSuccess() {
              Notification(
                'success',
                intl.formatMessage({
                  id: `message.updateSuccess`,
                }),
              );
            },
            onError(error) {
              Notification(
                'error',
                error.message ?? intl.formatMessage({ id: 'message.commonError' }),
              );
            },
          });
        }
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (!data) {
    return null;
  }

  return (
    <ContentWrapper title="Chỉnh sửa">
      <UserForm
        onSubmit={handleSubmit}
        isLoading={updateMutation.isLoading}
        initialValues={data}
      />
    </ContentWrapper>
  );
}
